import config from '../config/config';

const MAPION_BASE_URL = config.urls.mapionBaseUrl;
const URL_PARTS_PHONEBOOK = config.search.phonebook.urlPartsPhonebook;
const URL_PARTS_ADDRESS = config.search.phonebook.urlPartsAddress;
const URL_PARTS_STATION = config.search.phonebook.urlPartsStation;
const TMP_CATEGORY2_CODE = config.search.phonebook.tmpCategory2Code;
const TMP_CITY_CODE = config.search.phonebook.tmpCityCode;
const CITY_CODE_LENGTH = config.search.phonebook.cityCodeLength;

const TAXONOMY_ADDRESS = config.search.itemType.address;
const TAXONOMY_GOURMET = config.search.itemType.gourmet;
const TAXONOMY_ZIP = config.search.itemType.zip;
const TYPE_MAJOR_SPOT = config.search.itemType.majorSpot;
const TYPE_STATION = config.search.itemType.station;
const TYPE_PREF = config.search.itemType.pref;
const TYPE_CITY = config.search.itemType.city;

/**
 * 検索結果アイテムから外部リンク（電話帳等）を返す。
 * 存在しない場合は null を返す。
 */
export function getResultLink(item) {
  if (!item) return null;

  // 分類1:住所または郵便番号の場合、リンクなし
  if (item.taxonomy === TAXONOMY_ADDRESS || item.taxonomy === TAXONOMY_ZIP) {
    return null;
  }

  // 分類2:主要スポット（POIコードなし）の場合、リンクなし
  if (item.type === TYPE_MAJOR_SPOT && !item.poi_code) {
    return null;
  }

  // 分類3:グルメの場合
  if (item.taxonomy === TAXONOMY_GOURMET) {
    // ホットペッパー/ぐるなびのリンクがあればそちらを優先、なければ電話帳
    if (item.hotpepper_flag === 1 && item.hotpepper_link_url) {
      return item.hotpepper_link_url;
    }
    if (item.gurunavi_flag === 1 && item.gurunavi_link_url) {
      return item.gurunavi_link_url;
    }
    const category2Code = Array.isArray(item.category2_code) ? item.category2_code[0] : TMP_CATEGORY2_CODE;
    const cityCode = item.city_code || TMP_CITY_CODE;
    return `${MAPION_BASE_URL}/${URL_PARTS_PHONEBOOK}/${category2Code}/${cityCode}/${item.poi_code}/`;
  }

  // 分類4:電話帳の場合（POIコードがある）、POIコードから電話帳ページにリンク
  if (item.poi_code) {
    const category2Code = Array.isArray(item.category2_code) ? item.category2_code[0] : TMP_CATEGORY2_CODE;
    const cityCode = item.city_code || TMP_CITY_CODE;
    return `${MAPION_BASE_URL}/${URL_PARTS_PHONEBOOK}/${category2Code}/${cityCode}/${item.poi_code}/`;
  }

  // 分類5:駅の場合、駅コードから電話帳ページにリンク
  // 駅検索（カテゴリで駅選択を含む）でヒット:taxonomy=station
  // ワード検索でXX駅がヒット:type=station
  if (item.type === TYPE_STATION || item.taxonomy === TYPE_STATION) {
    // 駅検索でヒット:station_code=駅コード
    // ワード検索の結果:id=駅コード
    const stationCode = item.station_code || item.id;
    return `${MAPION_BASE_URL}/${URL_PARTS_STATION}/${encodeURIComponent(String(stationCode))}/`;
  }

  // 分類6:行政区画の場合
  // 分類6.1:都道府県コードから住所ページにリンク
  if (item.type === TYPE_PREF) {
    return `${MAPION_BASE_URL}/${URL_PARTS_ADDRESS}/${encodeURIComponent(String(item.pref_code))}/`;
  }
  // 分類6.2:市区町村コードから住所ページにリンク
  if (item.type === TYPE_CITY) {
    // idの例:"CITY1111100" 末尾5桁が市区町村コード
    const cityCode = item.id ? String(item.id).slice(-CITY_CODE_LENGTH) : '';
    return `${MAPION_BASE_URL}/${URL_PARTS_ADDRESS}/${encodeURIComponent(String(cityCode))}/`;
  }

  return null;
}